/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_Secured_SiteInputs */

const en_cad_field_secured_site = /** @type {(inputs: Cad_Field_Secured_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was access also refused (secured site)?`)
};

const ja_cad_field_secured_site = /** @type {(inputs: Cad_Field_Secured_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセスも拒否されましたか（セキュアサイト）？`)
};

const fr_cad_field_secured_site = /** @type {(inputs: Cad_Field_Secured_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'accès a-t-il aussi été refusé (site sécurisé) ?`)
};

const de_cad_field_secured_site = /** @type {(inputs: Cad_Field_Secured_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurde zusätzlich der Zugang verweigert (gesicherter Standort)?`)
};

/**
* | output |
* | --- |
* | "Was access also refused (secured site)?" |
*
* @param {Cad_Field_Secured_SiteInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_secured_site = /** @type {((inputs?: Cad_Field_Secured_SiteInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_Secured_SiteInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_secured_site(inputs)
	if (locale === "ja") return ja_cad_field_secured_site(inputs)
	if (locale === "fr") return fr_cad_field_secured_site(inputs)
	return de_cad_field_secured_site(inputs)
});